import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RouterSelectors } from '@next/core-lib/router-store';
import { SiteState } from '@next/core-lib/site';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import appData from '../../../shared/appData';
import { Contactperson } from '../../models/contactperson.model';
import { upsertContactpersonRequest } from '../../store/contactperson.actions';
import { getSelectedContactperson } from '../../store/contactperson.selectors';

@Component({
  selector: 'app-contactperson-detail',
  templateUrl: './contactperson-detail.component.html',
  standalone: false,
})
export class ContactpersonDetailComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  countries = appData.countries;

  form: FormGroup = new FormGroup({
    id: new FormControl(null),
    firstName: new FormControl(null, Validators.required),
    lastName: new FormControl(null, Validators.required),
    emailAddress: new FormControl(null, [Validators.required, Validators.email]),
    street: new FormControl(null),
    postalCode: new FormControl(null),
    houseNumber: new FormControl(null, [Validators.min(1)]),
    houseNumberAddition: new FormControl(null),
    city: new FormControl(null),
    country: new FormControl(null, Validators.required),
    phoneNumber: new FormControl(null),
    mobileNumber: new FormControl(null),
  });

  contactperson$: Observable<Contactperson> = this.store.select(getSelectedContactperson);

  details$: Observable<Contactperson> = this.contactperson$.pipe(
    filter((val) => !!val && Object.entries(val).length > 0),
    take(1),
  );

  routeUrl$: Observable<string> = this.store.pipe(select(RouterSelectors.getUrl));

  save() {
    if (this.form.valid) {
      this.contactperson$.pipe(take(1)).subscribe((contactperson) => {
        this.store.dispatch(
          upsertContactpersonRequest({
            contactperson: {
              ...this.form.value,
              id: contactperson ? contactperson.id : undefined,
            },
          }),
        );
      });
    }
  }
}
